module.exports = __webpack_public_path__ + "img/t-suite.78d58922.png";